import { render, staticRenderFns } from "./SlideWrapper.vue?vue&type=template&id=19c4251c&scoped=true"
import script from "./SlideWrapper.vue?vue&type=script&lang=js"
export * from "./SlideWrapper.vue?vue&type=script&lang=js"
import style0 from "./SlideWrapper.vue?vue&type=style&index=0&id=19c4251c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4251c",
  null
  
)

export default component.exports